import instance from '../request';

export const getProgramPlatformHash = () => instance.get('/api/v1/users/exam_encrypt_text/')
